import { Controller } from "stimulus";
import "mmenu-js";

export default class extends Controller {
  static targets = ["page", "menu", "showButton", "hideButton"];

  connect() {
    new Mmenu(
      "#menu",
      {
        navbar: {
          title: "Core",
        },
        scrollBugFix: {
          fix: true,
        },
        counters: {
          add: true,
        },
        theme: "dark",
        iconPanels: {
          add: false,
          visible: 1,
        },
        navbars: [
          {
            position: "top",
            content: ["searchfield"],
          },
        ],
        setSelected: {
          hover: true,
        },
      },
      {
        language: "pt_br",
        scrollBugFix: {
          fix: true,
        },
        offCanvas: {
          page: {
            nodetype: "main",
            selector: "#page",
          },
        },
      }
    );

    document.addEventListener("turbolinks:load", () => {
      let menuCloseLink = document.getElementById("mm-1");
      if (menuCloseLink) {
        menuCloseLink.remove();
        this.pageTarget.inert = false;
      }
      if (this.pageTarget) {
        this.pageTarget.classList.remove('mm-page', 'mm-slideout');
      }
    });


    const savedState = localStorage.getItem("menuState");
    if (savedState === "open") {
      this.showMenu();
    } else if (savedState === "closed") {
      this.hideMenu();
    } else {
      if (window.innerWidth > 769) {
        this.showMenu();
      } else {
        this.hideMenu();
      }
    }


    document.addEventListener("keydown", (event) => {
      if (event.altKey) this.showMenu();
      else if (event.key == "Escape") this.hideMenu();
    });


    this.initializeTooltips();
  }

  initializeTooltips() {
    let tooltip = document.querySelector(".menu-tooltip");
    if (!tooltip) {
      tooltip = document.createElement("div");
      tooltip.classList.add("menu-tooltip");
      document.body.appendChild(tooltip);
    }

    this.menuTarget.addEventListener("mouseover", (e) => {
      const link = e.target.closest(".mm-listitem a");
      if (!link || !document.body.classList.contains("menu--closed")) return;

      const temp = link.cloneNode(true);
      temp.querySelectorAll("i, .mm-counter, span").forEach((el) => el.remove());
      const text = temp.textContent.trim();


      const rect = link.getBoundingClientRect();
      tooltip.textContent = text;

      Object.assign(tooltip.style, {
        display: "block",
        position: "fixed",
        left: `${rect.right + 8}px`,
        top: `${rect.top + rect.height / 2}px`,
        transform: "translateY(-50%)",
      });
    });


    this.menuTarget.addEventListener("mouseout", (e) => {
      if (e.target.closest(".mm-listitem a")) {
        tooltip.style.display = "none";
      }
    });
  }

  showMenu() {
    document.body.classList.remove("menu--closed");
    this.showButtonTarget.classList.add("is-hidden");
    this.showButtonTarget.click();
    this.hideButtonTarget.classList.remove("is-hidden");

    let container = document.getElementsByTagName("main");
    this.pageTarget.inert = false;
    this.menuTarget.inert = false;

    this.menuTarget.style.width = "300px";
    container[0].style.paddingLeft = "300px";

    localStorage.setItem("menuState", "open");
  }

  hideMenu() {
    document.body.classList.add("menu--closed");
    this.hideButtonTarget.classList.add("is-hidden");
    this.showButtonTarget.classList.remove("is-hidden");
    this.hideButtonTarget.click();

    let container = document.getElementsByTagName("main");
    this.pageTarget.inert = false;
    this.menuTarget.inert = false;

    this.menuTarget.style.width = "64px";
    container[0].style.paddingLeft = "64px";

    localStorage.setItem("menuState", "closed");
  }
}
